// extracted by mini-css-extract-plugin
export default {"companyRoutesPanel":"CompanyRoutesPanel_companyRoutesPanel__kQSGw"};